<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form>
      <div class="d-flex align-items-center gap-2 flex-wrap master-filter-row">
        <div class="d-flex align-items-center gap-2 flex-wrap flex-auto">
          <div class="input-group input-group-sm master-search-group">
            <input type="text" class="form-control" name="searchQuery"
                   placeholder="ค้นหาเนื้อหาหรือหมายเหตุ..."
                   [(ngModel)]="searchQuery" (keyup.enter)="onSearchChange()" />
            <button class="btn btn-default" (click)="onSearchChange()" type="button">
              <i class="bi bi-search"></i>
            </button>
          </div>
          <button type="reset" class="btn btn-sm btn-default" (click)="clearSearch()">ล้าง</button>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
        <tr>
          <th class="text-center w-60px">No.</th>
          <th nowrap>รหัสสถานะ</th>
          <th nowrap>เนื้อหา</th>
          <th nowrap class="text-center">เงื่อนไข</th>
          <th nowrap>ระบบงานที่นำไปใช้</th>
          <th nowrap class="text-center">จำนวนที่นำไปใช้งาน</th>
          <th nowrap>ผู้บันทึก/วันที่บันทึก</th>
          <th nowrap>หมายเหตุ</th>
        </tr>
        </thead>
        <tbody>
          @if (isLoading()) {
            <tr>
              <td colspan="8" class="text-center py-5">กำลังโหลดข้อมูล...</td>
            </tr>
          } @else if (displayedItems().length === 0) {
            <tr>
              <td colspan="8" class="empty-cell">
                - ไม่มีข้อมูล -
              </td>
            </tr>
          } @else {
            @for (item of displayedItems(); track item.id ?? $index; let i = $index) {
              <tr>
                <td class="text-center">{{ (page() - 1) * pageSize() + i + 1 }}</td>
                <td nowrap class="fw-semibold">{{ item.statusCode || '-' }}</td>
                <td nowrap>{{ item.activityDesc || '-' }}</td>
                <td class="text-center">
                  <span class="result-badge"
                        [class.result-badge--success]="getResultTone(item.result) === 'success'"
                        [class.result-badge--danger]="getResultTone(item.result) === 'danger'">
                    {{ getResultLabel(item.result) }}
                  </span>
                </td>
                <td nowrap>{{ item.viewName || '-' }}</td>
                <td class="text-center">{{ item.amount ?? 0 }}</td>
                <td nowrap>{{ item.created | thaidatetime }}</td>
                <td nowrap class="text-muted">{{ item.remark || '-' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span class="me-2 text-body-secondary">แสดง</span>
      <app-pagesize-select [value]="pageSize()" (valueChange)="pageSize.set($event); load()"/>
      <span class="ms-2 text-body-secondary">จาก {{ collectionSize() }} รายการ</span>
    </div>
    <ngb-pagination [collectionSize]="collectionSize()"
                    [page]="page()"
                    [pageSize]="pageSize()"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="page.set($event); load()">
    </ngb-pagination>
  </div>
</div>
